module.exports = __webpack_public_path__ + "img/067.f6b97813.jpg";